var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Qualifications")]),_vm._v(" "),_c('div',{staticClass:"box-content"},[_c('ul',{staticClass:"qualification-list"},_vm._l((_vm.qualifications),function(item){return _c('li',[_c('p',{staticClass:"qualification"},[_vm._v(_vm._s(item))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e5658fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/QualificationList.vue
// module id = null
// module chunks = 